import service from '@/plugins/service'

const base = '/system/log'

export const getSystemLog = params => {
  return service({
    url: `${base}`,
    methods: 'get',
    params
  })
}

export const getDeviceModificationCnt = (params, data) => service({
  url: `${base}/device/query`,
  method: 'POST',
  params,
  data
})

export const getDeviceModificationDetail = (params, data) => service({
  url: `${base}/device/list`,
  method: 'GET',
  params,
  data
})